import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { parse } from 'query-string';
import { iFMessage } from '../../hoc/IntlComponents';
import { array, object, func } from 'prop-types';
import {
  startSetEditProfile,
  startSetProfile,
  startConfirmPhone,
  startSetSocialAccount,
  startRemoveSocialAccount,
  startSetBotsInfo,
  startSetNotify,
  startEditNotify,
} from '../../actions/webmaster';
import { startSetAppSettings, startSetSocials } from '../../actions/app';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import ProfileEditForm from '../../components/Profile/ProfileEditForm';
import AlertModal from '../../modals/AlertModal/AlertModal';
import ConfirmSMSModal from '../../modals/ConfirmSMSModal/ConfirmSMSModal';
import WithAlert from '../../hoc/WithAlert';
import { LocalStorage } from '../../utils/utils';

class ProfilePage extends Component {
  static propTypes = {
    profile: object.isRequired,
    timezones: array.isRequired,
    startSetEditProfile: func,
    startSetProfile: func,
    startConfirmPhone: func,
  };

  static defaultProps = {
    profile: {},
    timezones: [],
  };

  state = {
    error: false,
    smsModal: false,
    loading: false,
    errors: {},
    phone: '',
    modalType: 'call',
    accountErrors: {},
    notifications: [],
  };

  componentDidMount() {
    const {
      profile: { email },
      intl,
    } = this.props;
    if (!email.trim().length) {
      this.props.showAlert({
        alertType: 'danger',
        dismissable: false,
        message: iFMessage({ intl, id: 'profile.alert.no-email' }),
      });
    }

    this.setState({ loading: true });

    this.props
      .startSetSocials()
      .then(() => this.getAccessData())
      .then((data) => this.addSocialAccount(data))
      .then(() => this.props.startSetBotsInfo())
      .then(() => this.props.startSetNotify())
      .then(({ notifications }) => this.setState({ notifications }))
      .then(() => this.setState({ loading: false }));

    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.profile.email.trim().length) {
      if (
        nextProps.profile &&
        nextProps.profile.email &&
        nextProps.profile.email !== this.props.profile.email
      ) {
        this.props.closeAlert();
      }
    }
  }

  handleSavePhone = (phone) => {
    this.sendSMS({ phone });
  };

  toggleSmsModal = () => {
    this.setState((prevState) => ({
      smsModal: !prevState.smsModal,
      errors: { ...prevState.errors, phone_confirmation: '' },
    }));
  };

  toggleErrorModal = () => {
    this.setState((prevState) => ({ error: !prevState.error }));
  };

  sendSMS = (data) => {
    this.setState({ loading: true });
    this.props
      .startConfirmPhone(data)
      .then((response) => {
        if (data.code) {
          this.props.startSetProfile().then(() => {
            if (this._isMounted) {
              return this.setState(() => ({
                loading: false,
                smsModal: false,
                phone: '',
              }));
            }
          });
        } else {
          const modalType = response?.items[0]?.transport;
          this.setState(() => ({
            smsModal: true,
            phone,
            modalType,
            loading: false,
          }));
        }
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message } = response.data.error;
          if (this._isMounted) {
            if (data.code) {
              this.setState((prevState) => ({
                error: true,
                errors: {
                  ...prevState,
                  phone_confirmation: message.message,
                },
                phone: '',
                loading: false,
              }));
            } else {
              this.handleError(message.message);
              this.setState({
                loading: false,
              });
            }
          }
        }
      });
  };

  submit = (data) => {
    const { timezone, theme } = this.props.profile;

    if (this._isMounted) {
      this.setState(() => ({ loading: true }));
    }

    this.props
      .startSetEditProfile(data)
      .then(() => {
        this.setState({ accountErrors: {} });

        if ((data.timezone && data.timezone !== timezone) || (data.theme && data.theme !== theme)) {
          window.location.reload();
        }
        return this.props.startSetProfile();
      })
      .then(() => this.props.startSetAppSettings())
      .then(() => {
        if (this._isMounted) {
          this.setState(() => ({ loading: false }));
        }
      })
      .catch((error) => {
        const { response = {} } = error;
        const responseData = response?.data?.response;

        if (responseData?.validation_errors) {
          const accountErrors = {};

          responseData.validation_errors.forEach(({ wm_account, message }) => {
            accountErrors[wm_account] = message;
          });

          this.setState({ accountErrors });
        }

        this.setState({ loading: false });
      });
  };

  getSocials = () => Object.values(this.props.socials).map((social) => social);

  getAccounts = () =>
    this.props.accounts.reduce((accounts, acc) => ({ ...accounts, [acc.provider]: acc }), {});

  handleError = (message) => {
    this.props.showAlert({
      alertType: 'danger',
      dismissable: false,
      closeInSeconds: 3,
      message,
    });
  };

  handleUnsubscribe = (accountId) => {
    this.setState({ loading: true });
    const { startRemoveSocialAccount, intl } = this.props;

    startRemoveSocialAccount(accountId)
      .then(() => {
        this.props.showAlert({
          alertType: 'success',
          dismissable: false,
          closeInSeconds: 3,
          message: iFMessage({ intl, id: 'socials.account.disconnected' }),
        });

        this.setState({ loading: false });
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error } = response.data.error;
          this.handleError(error.message);
          this.setState({ loading: false });
        }
      });
  };

  getAccessData = () => {
    const { hash, search } = this.props.history.location;

    let params = parse(search);

    if (!params.code && !params.error && hash !== '#_=_') {
      params = parse(hash);
    }

    if ((params.access_token || params.code) && params.state) {
      try {
        const { security_hash, provider } = JSON.parse(params.state);
        const { expires_in, user_id } = params;
        const token = params.access_token || params.code;
        const { origin, pathname } = window.location;
        const redirect_uri = `${origin}${pathname}`;

        // сверяется случайное число, генерируемое при подключении, смотреть OFFERRUM-1129
        if (security_hash && security_hash === LocalStorage.get('security_hash')) {
          LocalStorage.remove('security_hash');
          return {
            token,
            expires_in,
            user_id,
            redirect_uri,
            provider,
          };
        } else {
          throw new Error('Security hash is invalid. Probably someone tries to hack you');
        }
      } catch (error) {
        this.handleError('There was an error when receiving an access key.');
        return null;
      }
    } else if (params.error && params.error_description) {
      this.handleError(decodeURIComponent(params.error_description));
    }

    return null;
  };

  removeParams = () => {
    this.props.history.replace(window.location.pathname);
  };

  addSocialAccount = (data) => {
    if (data !== null) {
      return this.props
        .startSetSocialAccount(data)
        .then(() => {
          const { intl, showAlert } = this.props;
          this.removeParams();
          showAlert({
            alertType: 'success',
            message: iFMessage({ intl, id: 'socials.account.connected' }),
            closeInSeconds: 5,
            dismissable: false,
          });
        })
        .catch(({ response = {} }) => {
          if (response.data && response.data.error) {
            const { message: error } = response.data.error;
            this.handleError(error.message);
          }

          setTimeout(() => {
            this.removeParams();
          }, 3000);
        });
    }
  };

  onChangeNotification = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState((prevState) => {
      const [index, type, field] = target.name.split('_');
      const notifications = [...prevState.notifications];

      if (type === 'params') {
        notifications[index].params[field].value = value;
      } else {
        notifications[index].transport[field].checked = value;
      }

      return { notifications };
    });
  };

  buildNotificationsDataString = () => {
    const { notifications } = this.state;
    let dataString = '';

    notifications.forEach((elem, index) => {
      let dataField = '';

      Object.keys(elem.transport).forEach((field) => {
        if (elem.transport[field].checked === true) {
          dataField += `settings[${index}][transport][]=${field}&`;
        }
      });

      Object.keys(elem.params).forEach((field) => {
        const { value } = elem.params[field];
        if (value) {
          dataField += `settings[${index}][params][${field}]=${value}&`;
        }
      });

      if (dataField) dataString += `settings[${index}][id]=${elem.id}&${dataField}`;
    });

    if (dataString.length === 0) dataString = 'settings[0][id]=1';

    return dataString;
  };

  submit = (data) => {
    const { timezone, theme } = this.props.profile;

    if (this._isMounted) {
      this.setState(() => ({ loading: true }));
    }

    Promise.all([
      this.props.startSetEditProfile(data),
      this.props.startEditNotify(this.buildNotificationsDataString()),
    ])
      .then(() => {
        this.setState({ accountErrors: {} });

        if ((data.timezone && data.timezone !== timezone) || (data.theme && data.theme !== theme)) {
          window.location.reload();
        }
        return this.props.startSetProfile();
      })
      .then(() => this.props.startSetAppSettings())
      .then(() => {
        if (this._isMounted) {
          this.setState(() => ({ loading: false }));
        }
      })
      .catch((error) => {
        const { response = {} } = error;
        const responseData = response?.data?.response;

        if (responseData?.validation_errors) {
          const accountErrors = {};

          responseData.validation_errors.forEach(({ wm_account, message }) => {
            accountErrors[wm_account] = message;
          });

          this.setState({ accountErrors });
        }

        this.setState({ loading: false });
      });
  };

  render() {
    const { loading, error, smsModal, errors, phone, modalType } = this.state;
    const { profile, timezones, bots } = this.props;
    const isTelegramConnected = !!(bots[0] && bots[0].enabled) || '';
    const telegramActivationCode = (bots[0] && bots[0].code) || '';
    const telegramBotLink = (bots[0] && bots[0].link) || '';

    return (
      <Layout>
        <Layout.Col className="mb-4" lg={{ size: 12 }}>
          {/* <Card loading={loading}> */}
          <Card.Header>
            <FormattedMessage id="profile.edit" defaultMessage="Edit Profile" />
          </Card.Header>
          {/* <Card.Body> */}
          <ProfileEditForm
            accountErrors={this.state.accountErrors}
            handleUnsubscribe={this.handleUnsubscribe}
            accounts={this.getAccounts()}
            socials={this.getSocials()}
            submit={this.submit}
            profile={profile}
            timezones={timezones}
            onSavingPhone={this.handleSavePhone}
            updateProfile={this.props.startSetProfile}
            telegramActivationCode={telegramActivationCode}
            telegramBotLink={telegramBotLink}
            isTelegramConnected={isTelegramConnected}
            notifications={this.state.notifications}
            onChangeNotification={this.onChangeNotification}
          />
          {/* </Card.Body> */}
          {/* </Card> */}
        </Layout.Col>

        {/* {errors.phone_confirmation && (
          <AlertModal
            className="sms-errors-modal"
            open={error}
            title={<FormattedMessage id="main.error" defaultMessage="Error" />}
            message={errors.phone_confirmation}
            onClose={this.toggleErrorModal}
          />
        )} */}

        <ConfirmSMSModal
          isPhoneCall={modalType === 'call'}
          isOpen={smsModal}
          phone={phone}
          error={errors.phone_confirmation}
          sendSms={this.sendSMS}
          onCancel={this.toggleSmsModal}
          toggleModal={this.toggleSmsModal}
        />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.webmaster.profile,
  timezones: state.app.globalSettings.timezones,
  socials: state.app.socials,
  accounts: state.webmaster.profile.socials,
  bots: state.webmaster.bots,
});

const mapDispatchToProps = (dispatch) => ({
  startSetEditProfile: (data) => dispatch(startSetEditProfile(data)),
  startSetProfile: (params) => dispatch(startSetProfile(params)),
  startConfirmPhone: (data) => dispatch(startConfirmPhone(data)),
  startSetAppSettings: () => dispatch(startSetAppSettings()),
  startRemoveSocialAccount: (accountId) => dispatch(startRemoveSocialAccount(accountId)),
  startSetSocials: () => dispatch(startSetSocials()),
  startSetSocialAccount: (data) => dispatch(startSetSocialAccount(data)),
  startSetBotsInfo: () => dispatch(startSetBotsInfo()),
  startSetNotify: () => dispatch(startSetNotify()),
  startEditNotify: (notifications) => dispatch(startEditNotify(notifications)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(WithAlert(ProfilePage)));
